import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditGuestLayer from "../components/EditGuestLayer";


const EditGuestPage = () => {
  return (
    <>


        {/* Breadcrumb */}
        <Breadcrumb title="Edit Student" />

        {/* UsersListLayer */}
        <EditGuestLayer />



    </>
  );
};

export default EditGuestPage; 